/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnteResDto } from '../../models/ente-res-dto';
import { UpdateEnteDto } from '../../models/update-ente-dto';

export interface EntiControllerUpdateEnte$Params {
  idEnte: number;
  body: UpdateEnteDto;
}

export function entiControllerUpdateEnte(
  http: HttpClient,
  rootUrl: string,
  params: EntiControllerUpdateEnte$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<EnteResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    entiControllerUpdateEnte.PATH,
    'patch',
  );
  if (params) {
    rb.path('idEnte', params.idEnte, {});
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<EnteResDto>;
      }),
    );
}

entiControllerUpdateEnte.PATH = '/admin/ente/id/{idEnte}';
